export default __webpack_public_path__ + "locales/hy-AM/Payments.json?hash=c88b596418c6e77befc7017d0085f4cd";